/**
 * Fonction d'aide pour exporter la base de données indexedDB au format JSON
 */
import db from "./db";
import { exportDB } from "dexie-export-import";
import { downloadFile } from "./utils";
import JSZip from 'jszip';

export async function exportDb() {

    let options = {};

    let blob = await exportDB(db, options);
    let zip = new JSZip();
    zip.file("export-myopen-db.json", blob);
    zip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
        compressionOptions: {
            level: 9
        }
    }).then(function (content) {
        var blobUrl = URL.createObjectURL(content);
        downloadFile(blobUrl, "export-myopen-db.zip");
    });
}

